import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiResponse } from '../../models/api.model';
import { User } from '../models/users.model';
import { UsersService } from '../services/users.service';

export type UsersResolveValue =
  { data: ApiResponse<User[]>; error: null } | { data: null; error: Error };

export const usersResolver = (
  route: ActivatedRouteSnapshot
): Observable<UsersResolveValue> => {
  const router = inject(Router);
  const usersService = inject(UsersService);
  const page = Number(route.queryParamMap.get('page')) || 1;

  return usersService.getAll$(page).pipe(
    map(response => ({ data: response, error: null })),
    catchError(error => {
      router.navigate(['/dashboard']);
      return of({ data: null, error });
    })
  );
};
